import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface IdaUserInputEvent {
    value: unknown;
    field?: string;
    raw?: Record<string, unknown>;
}

export interface IdaBotResponseEvent {
    message: unknown;
    raw?: Record<string, unknown>;
}

@Injectable({
    providedIn: 'root',
})
export class IdaMessageBridgeService {
    private readonly userInputSubject = new Subject<IdaUserInputEvent>();
    private readonly botResponseSubject = new Subject<IdaBotResponseEvent>();

    readonly userInput$: Observable<IdaUserInputEvent> =
        this.userInputSubject.asObservable();
    readonly botResponse$: Observable<IdaBotResponseEvent> =
        this.botResponseSubject.asObservable();

    publishUserInput(event: IdaUserInputEvent): void {
        this.userInputSubject.next(event);
    }

    publishBotResponse(event: IdaBotResponseEvent): void {
        this.botResponseSubject.next(event);
    }
}
